/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import find from 'lodash/find';
import get from 'lodash/get';
import {
  toggleHistoryFilter,
} from '../../actions';
import { historyFilteringOptions } from './lookups';

import checkBoxImg from '../../assets/images/checkBox.svg';
import checkBoxActiveImg from '../../assets/images/checkBoxActive.svg';

import './styles.css';

class HistoryFilter extends Component {
  onSelectToggle(evt) {
    evt.stopPropagation();
    let selectionCode = evt.target.getAttribute('selectioncode');
    if (!selectionCode) selectionCode = evt.target.parentElement.getAttribute('selectioncode');
    if (selectionCode) {
      this.props.toggleHistoryFilter(selectionCode);
    }
  }

  render() {
    const { selected: selectedProps, filterCategoryLengths } = this.props;
    return (
      <div styleName="headerFilter">
        {
          historyFilteringOptions.map((item) => {
            const isSelected = find(selectedProps, opt => item.code === opt);
            if (!filterCategoryLengths[item.code]) return null;
            return (
              <button
                key={item.code}
                selectioncode={item.code}
                onClick={evt => this.onSelectToggle(evt)}
                styleName={`headerFilterItem ${isSelected ? 'headerFilterItemActive' : ''}`}
              >
                <img onClick={evt => this.onSelectToggle(evt)} width="20" height="20" src={isSelected ? checkBoxActiveImg : checkBoxImg} alt="Selected" styleName="checkIcon" />
                {item.label}
              </button>
            );
          })
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selected: get(state, 'historyFilter.selected'),
});

const mapDispatchToProps = {
  toggleHistoryFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryFilter);



// WEBPACK FOOTER //
// ./src/components/History/HistoryFilter.js